export default __webpack_public_path__ + "static/media/StockFreezeUpload.19c15ce3.xlsx";